import { Flex } from "@rebass/grid";
import styled from "@rentiohq/web-theme";

export const SectionTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.neutral90};
`;

export const SectionSubtext = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.neutral80};
`;

export const SectionSubtextTruncated = styled(SectionSubtext)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  cursor: default;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.neutral80};
`;

export const TenantsContainer = styled.div`
  font-size: 12px;
`;

export const InfoContainer = styled(Flex)`
  width: 100%;
`;
